module.exports = __webpack_public_path__ + "img/1.b3a3c0d5.png";